import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import PropTypes from "prop-types";

export function CSFPivotalBrokerPasswordReset({apiUrl, apiEnv, type}) {

  const [email, setEmail] = useState('');
  const [emailLabel, setEmailLabel] = useState(type === 'member' ? window.Drupal.t('membre.login.username.label') : window.Drupal.t('broker.resetPassword'));
  const [successSubmit, setSuccessSubmit] = useState();

  const _getFormFieldWrapperClasses = function () {
    return 'js-form-item form-item js-form-type-password form-item-pass js-form-item-pass form-group';
  };

  function displaySuccessSubmit() {
    setSuccessSubmit(
      <div className="messagebox mb-2 py-2 px-2 px-md-5 messagebox-success">
        <div className="grid-container-large">
          <div className="d-flex flex-column flex-lg-row align-items-center">
            <i className="icon icon-csf-check color-fruit-salade">&nbsp;</i>
            <div>
              {type === "member" ? (
                <p className="messagebox-text mt-1">{window.Drupal.t('The password reset link has been sent to the email address associated with your account.')}</p>
              ) : (
                <p className="messagebox-text mt-1">{window.Drupal.t('The password reset link has been sent to the specified email address.')}</p>
              )}
              <p className="messagebox-text">{window.Drupal.t('Please check your inbox (and junk mail) for the link and follow the instructions to create a new password.')}</p>
              <p className="messagebox-text mb-1">{window.Drupal.t('If you have not received the email within the next few minutes, please do not hesitate to contact us.')}</p>
            </div>

          </div>
        </div>
      </div>,
    );
  }

  function startLoadingSpinner() {
    // spinner markup is already in pages
    const background = document.querySelectorAll('.ui-loader-background');
    const loader = document.querySelectorAll('#loader');

    if (background !== undefined && background !== null) {
      if (loader !== undefined && loader !== null) {
        background[0].style.display = 'block';
        loader[0].style.visibility = 'visible';
      }
    }
  }

  function stopLoadingSpinner() {
    // spinner markup is already in pages
    const background = document.querySelectorAll('.ui-loader-background');
    const loader = document.querySelectorAll('#loader');

    if (background !== undefined && background !== null) {
      if (loader !== undefined && loader !== null) {
        background[0].style.display = 'none';
        loader[0].style.visibility = 'hidden';
      }
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    //Show spinner
    startLoadingSpinner();

    const recipeUrl = apiUrl;
    const postBody = {
      email: email,
    };

    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': apiEnv,
      },
      body: JSON.stringify(postBody),
    };

    fetch(recipeUrl, requestMetadata)
      .then(res => res.json())
      .then(data => {
        //Doesnt show if error for security
        displaySuccessSubmit();
        stopLoadingSpinner();
      })
      .catch(function (error) {
        stopLoadingSpinner();
      });
  }

  return (
    <form className="broker-password-reset-form" autoComplete="on"
          onSubmit={handleSubmit}>

      {successSubmit}

      <div className={_getFormFieldWrapperClasses()}>
        <label htmlFor="resetPasswordFormEmailInput"
               className="js-form-required form-required">
          {emailLabel}
        </label>
        <input autoCorrect="none" autoCapitalize="none" spellCheck="false"
               type="email"
               id="resetPasswordFormEmailInput"
               name="resetPasswordFormEmailInput"
               value={email}
               onChange={e => setEmail(e.target.value)}
               size="15" maxLength="60"
               className="form-text required" required="required"
               aria-required="true"/>
      </div>

      <div>
        <p>{window.Drupal.t('Password reset instructions will be sent to your registered email address.')}</p>
      </div>

      <div data-drupal-selector="edit-actions"
           className="form-actions js-form-wrapper form-wrapper"
           id="edit-actions">
        <input type="submit"
               name="op"
               value={window.Drupal.t('Submit')}
               className="button js-form-submit form-submit btn-primary btn"/>
      </div>
    </form>
  );
}

window.addEventListener('DOMContentLoaded', () => {

  const domNode = document.getElementById('CSFPivotalBrokerPasswordReset');

  if (domNode !== null) {
    const root = createRoot(domNode);
    const apiUrl = domNode.getAttribute('data-api-url');
    const apiEnv = domNode.getAttribute('data-api-env');
    const type = domNode.getAttribute('data-type') ?? '';

    root.render(<CSFPivotalBrokerPasswordReset
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      type={type}
    />);
  }
});

CSFPivotalBrokerPasswordReset.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  type: PropTypes.string,
};
